import { createAction } from '@af-common/Common/_actions/Action';

export enum DocumentActionType {
	OnChangeDesignId	= 'ON_CHANGE_DESIGNID',
	OnChangeName		= 'ON_CHANGE_NAME',
	OnChangeOffsetX		= 'ON_CHANGE_OFFSETX',
	OnChangeOffsetY		= 'ON_CHANGE_OFFSETY',
	OnChangeWidth		= 'ON_CHANGE_WIDTH',
	OnChangeHeight		= 'ON_CHANGE_HEIGHT',
	OnChangeDPI			= 'ON_CHANGE_DPI',
	OnChangeQuality		= 'ON_CHANGE_QUALITY',
	OnIncreaseQuality	= 'ON_INCREASE_QUALITY',
	OnDecreaseQuality	= 'ON_DECREASE_QUALITY',
	OnZoom				= 'ON_ZOOM',
	OnChangeUnits		= 'ON_CHANGE_UNITS',
	OnChangeStatus		= 'ON_CHANGE_STATUS',
	OnChangeLockRatio	= 'ON_CHANGE_LOCK_RATIO',
	OnChangeUseChunks	= "ON_CHANGE_USE_CHUNKS",
	OnAttachModule		= 'ON_ATTACH_MODULE',
}

export const OnChangeDesignId = (value: number) => createAction(DocumentActionType.OnChangeDesignId, {
	value: value
});

export const OnChangeName = (value: string) => createAction(DocumentActionType.OnChangeName, {
	value: value
});

export const OnChangeOffsetX = (value: number) => createAction(DocumentActionType.OnChangeOffsetX, {
	value: value
});

export const OnChangeOffsetY = (value: number) => createAction(DocumentActionType.OnChangeOffsetY, {
	value: value
});

export const OnChangeWidth = (value: number) => createAction(DocumentActionType.OnChangeWidth, {
	value: value
});

export const OnChangeHeight = (value: number) => createAction(DocumentActionType.OnChangeHeight, {
	value: value
});

export const OnChangeDPI = (value: number, limit: boolean = false) => createAction(DocumentActionType.OnChangeDPI, {
	value: value,
	limit: limit
});

export const OnChangeQuality = (value: number) => createAction(DocumentActionType.OnChangeQuality, {
	value: value
});

export const OnIncreaseQuality = (maxQuality: number) => createAction(DocumentActionType.OnIncreaseQuality, {
	maxQuality: maxQuality
});
export const OnDecreaseQuality = () => createAction(DocumentActionType.OnDecreaseQuality);

export const OnZoom = (zoom:number, offsetX:number = 0, offsetY:number = 0) => createAction(DocumentActionType.OnZoom, {
	zoom: zoom,
	offsetX: offsetX,
	offsetY: offsetY,
});

export const OnChangeUnits = (value: string) => createAction(DocumentActionType.OnChangeUnits, {
	value: value
});

export const OnChangeStatus = (value: string) => createAction(DocumentActionType.OnChangeStatus, {
	value: value
});

export const OnChangeLockRatio = (value: boolean) => createAction(DocumentActionType.OnChangeLockRatio, {
	value: value
});

export const OnChangeUseChunks = (value: boolean) => createAction(DocumentActionType.OnChangeUseChunks, {
	value: value
});

export const OnAttachModule = (moduleId: string) => createAction(DocumentActionType.OnAttachModule, {
	moduleId: moduleId
});

export type DocumentAction = 
	ReturnType<typeof OnChangeDesignId>		|
	ReturnType<typeof OnChangeName>			|
	ReturnType<typeof OnChangeOffsetX>		|
	ReturnType<typeof OnChangeOffsetY>		|
	ReturnType<typeof OnChangeWidth>		|
	ReturnType<typeof OnChangeHeight>		|
	ReturnType<typeof OnChangeDPI>			|
	ReturnType<typeof OnChangeQuality>		|
	ReturnType<typeof OnIncreaseQuality>	|
	ReturnType<typeof OnDecreaseQuality>	|
	ReturnType<typeof OnZoom>				|
	ReturnType<typeof OnChangeUnits>		|
	ReturnType<typeof OnChangeStatus>		|
	ReturnType<typeof OnChangeLockRatio> 	|
	ReturnType<typeof OnChangeUseChunks>	|
	ReturnType<typeof OnAttachModule>
